import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import FormContainer from '@starbucks-web/pattern-library/lib/components/form-container/';
import FormWithMessaging from 'shared/app/components/form-with-messaging';
import LegacyPaddedContentColumn from 'shared/app/components/legacy-padded-content-column';
import { FormattedMessage } from 'react-intl';

import { showErrorNotification } from 'shared/app/shell';
import { formMessages } from 'shared/app/messages';
import { validatePassword } from 'shared/app/components/password-field-with-validation/validator';

import { resetForgottenPassword } from '../../state/action-creators';
import { resetPasswordTokenSelector } from '../../state/selectors';

import ResetPasswordColumn from './content-column';
import errorMessages from './messages';

const messages = Object.assign({}, errorMessages, formMessages);

const fields = {
  newPassword: {
    validator: validatePassword,
  },
};

export class ResetPassword extends Component {
  constructor() {
    super();

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitServerError = this.handleSubmitServerError.bind(this);
  }

  setFieldError(errorMessage, fieldName = 'newPassword') {
    this.$formContainer.updateField({
      errorMessage,
      hasServerSideError: true,
      input: {
        name: fieldName,
        value: '',
      },
    });
    this.$formContainer.focusOnFirstInvalid([fieldName]);
  }

  handleSubmitServerError(error) {
    switch (error?.data?.code) {
      case '111084': // 1121
        this.setFieldError(messages.newPasswordInvalidReuse);
        break;
      case '111011': // 1018
        this.setFieldError(messages.resetPasswordMissing);
        break;
      case '111022':
        this.setFieldError(messages.invalidPassword);
        break;
      default:
        this.props.showErrorNotification({
          messageId: messages.resetPasswordError.id,
        });
    }
  }

  handleSubmit({ newPassword }) {
    const { resetPasswordToken } = this.props;
    const formData = {
      newPassword,
      token: resetPasswordToken,
    };
    this.props
      .resetForgottenPassword(formData)
      .catch(this.handleSubmitServerError);
  }

  render() {
    return (
      <LegacyPaddedContentColumn size="sm">
        <p className="py3 color-textBlackSoft">
          <FormattedMessage {...messages.resetPasswordEnterPasswordTest} />
        </p>
        <FormContainer
          fields={fields}
          onSubmit={this.handleSubmit}
          ref={(el) => (this.$formContainer = el)}
        >
          <FormWithMessaging>
            <ResetPasswordColumn />
          </FormWithMessaging>
        </FormContainer>
      </LegacyPaddedContentColumn>
    );
  }
}

ResetPassword.propTypes = {
  onSubmit: PropTypes.func,
  resetPasswordToken: PropTypes.string,
};

const select = (state) => ({
  resetPasswordToken: resetPasswordTokenSelector(state),
});

const actions = { resetForgottenPassword, showErrorNotification };

export default connect(select, actions)(ResetPassword);
